import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { Fade, useMediaQuery, useTheme } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import FsUsersManagementTable from 'ui-elements/tables/FsUsersManagementTable';
import FsPagination from 'ui-elements/tabs/FsPagination';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsButton from 'ui-elements/buttons/FsButton';
import FsAddNewUserModal from 'ui-elements/modals/FsAddNewUserModal';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import { PaginationWrapperBox } from './UsersManagement.style-elements';
import {
  dummyPagination,
  longerHeadLabels,
  shorterHeadLabels,
} from './UsersManagement.utils';

const { teammates: teammatesLocales } = defaultLocales.settingsPage;

export interface UsersManagementProps {
  inStatus: boolean;
  timeout?: number;
}

const UsersManagement: React.FC<UsersManagementProps> = ({
  inStatus,
  timeout = 1000,
}) => {
  const {
    teammatesList: { data: teammatesList, init: initTeammatesList },
  } = useAppContext();
  const [showModal, setShowModal] = useState<boolean>(false);
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });
  const isUpLg = useMediaQuery(theme.breakpoints.up('lg'), {
    noSsr: true,
  });

  useEffect(() => {
    initTeammatesList();
  }, [initTeammatesList]);

  const buttons = [
    <FsButton
      variant="contained"
      color="primary"
      key={1}
      onClick={() => setShowModal(true)}
    >
      {isUpSm ? defaultLocales.inviteNewTeammate : defaultLocales.invite}
    </FsButton>,
  ];

  return (
    <Fade in={inStatus} timeout={timeout}>
      <FsPaper
        title={teammatesLocales.title}
        subTitle={teammatesLocales.subTitle}
        buttons={buttons}
      >
        <FsMinWidthScrollBox breakpointDown="md" minWidth={600}>
          <FsUsersManagementTable
            rows={getSnapshot(teammatesList)}
            headLabels={isUpLg ? longerHeadLabels : shorterHeadLabels}
          />
        </FsMinWidthScrollBox>
        <FsMinWidthScrollBox minWidth={290}>
          <PaginationWrapperBox>
            <FsPagination paginationInfo={dummyPagination} />
          </PaginationWrapperBox>
        </FsMinWidthScrollBox>
        {showModal && <FsAddNewUserModal onClose={() => setShowModal(false)} />}
      </FsPaper>
    </Fade>
  );
};

export default observer(UsersManagement);
